/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const isCorporateMode = process.env.REACT_APP_CORPORATE === '1'

export const DEFAULT_AUTHENTICATED_ROUTE = isCorporateMode
  ? '/corporate'
  : '/dashboard'

export default {
  algorithm: process.env.REACT_APP_ALGORITHM!,
  password: process.env.REACT_APP_PASSWORD!,
  backend: process.env.REACT_APP_BACKEND!,
  socketserver: process.env.REACT_APP_SOCKETSERVER!,
  allowMavis: process.env.REACT_APP_ALLOWMAVIS
}
